module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 220
// module chunks = 0